// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1aIBP","subheader":"ReorderModal_subheader__3khWC","listWrap":"ReorderModal_listWrap__gASi2"};